"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSupportedVaults = void 0;
const utils_1 = require("../utils");
const yearn_sdk_1 = require("./yearn-sdk");
const getSupportedVaults = async () => {
    const vaults = await yearn_sdk_1.yearnSdk.vaults.get();
    return vaults.map(utils_1.transformVault);
};
exports.getSupportedVaults = getSupportedVaults;
